import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getOfferDisplayName } from '../../utils/offerMapping';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import appDemoVideo from '../../assets/0218(1).mp4';
import app20Logo from '../../assets/App20_New_Logo.png';

export default function ActiveOfferPage() {
  const navigate = useNavigate();
  const [offerAmount, setOfferAmount] = useState('25');
  const [offerName, setOfferName] = useState('Offer A');

  useEffect(() => {
    const savedAmount = localStorage.getItem('current_offer_amount');
    const savedName = localStorage.getItem('current_form_name');
    if (savedAmount) setOfferAmount(savedAmount);
    if (savedName) setOfferName(savedName);
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#F2F5F1', display: 'flex', flexDirection: 'column' }}>
      
      {/* Dark Green Top Section */}
      <Box sx={{ 
        bgcolor: '#0F231A', 
        pt: 3, 
        pb: 18, 
        px: 2.5, 
        borderBottomLeftRadius: '36px', 
        borderBottomRightRadius: '36px',
        position: 'relative',
        zIndex: 1
      }}>
        <Container maxWidth="sm" sx={{ p: 0 }}>
          {/* Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <img
              src={app20Logo}
              alt="logo of App20"
              style={{ height: '32px', objectFit: 'contain' }}
            />
          </Box>

          {/* Today's Offer Badge / Subtitle */}
          <Typography sx={{ 
            color: '#C9F23C', 
            fontSize: '12px', 
            fontWeight: 800, 
            letterSpacing: '1px', 
            mb: 1.5, 
            fontFamily: '"Plus Jakarta Sans", sans-serif' 
          }}>
            TODAY'S OFFER
          </Typography>

          {/* Main Title */}
          <Typography sx={{ 
            color: '#FFFFFF', 
            fontSize: { xs: '32px', sm: '36px' }, 
            fontWeight: 700, 
            lineHeight: 1.15, 
            letterSpacing: '-1px', 
            fontFamily: '"Moan Slight", sans-serif' 
          }}>
            Earn ₹{offerAmount} in about<br />2 minutes
          </Typography>
        </Container>
      </Box>

      {/* Content Container (Card overlapping the dark green header) */}
      <Container maxWidth="sm" sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', px: 2, position: 'relative', zIndex: 2, mt: -12 }}>

        {/* Main Active Offer Card */}
        <Box sx={{ bgcolor: '#fff', borderRadius: '24px', p: 2.5, mb: 4, boxShadow: '0 8px 30px rgba(0,0,0,0.08)' }}>
          {/* Offer Details */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Box sx={{ width: 56, height: 56, bgcolor: '#0F763F', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 'bold', fontSize: '24px', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                {getOfferDisplayName(offerName).charAt(0).toUpperCase()}
              </Box>
              <Box>
                <Typography sx={{ color: '#000', fontWeight: 800, fontSize: '18px', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                  {getOfferDisplayName(offerName)}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ bgcolor: '#C9F23C', px: 2, py: 0.5, borderRadius: '12px' }}>
              <Typography sx={{ color: '#000', fontWeight: 900, fontSize: '18px', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                ₹{offerAmount}
              </Typography>
            </Box>
          </Box>

          {/* Steps */}
          <Box sx={{ display: 'flex', gap: 1.5, mb: 3 }}>
            {/* Step 1 */}
            <Box sx={{ flex: 1, bgcolor: '#F5F6F3', borderRadius: '12px', p: 1.5 }}>
              <Box sx={{ width: 24, height: 24, bgcolor: '#0F231A', borderRadius: '50%', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 800, mb: 1, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                1
              </Box>
              <Typography sx={{ color: '#000', fontSize: '13px', fontWeight: 700, lineHeight: 1.2, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                Install the app
              </Typography>
            </Box>
            {/* Step 2 */}
            <Box sx={{ flex: 1, bgcolor: '#F5F6F3', borderRadius: '12px', p: 1.5 }}>
              <Box sx={{ width: 24, height: 24, bgcolor: '#0F231A', borderRadius: '50%', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 800, mb: 1, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                2
              </Box>
              <Typography sx={{ color: '#000', fontSize: '13px', fontWeight: 700, lineHeight: 1.2, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                Upload a screenshot
              </Typography>
            </Box>
            {/* Step 3 */}
            <Box sx={{ flex: 1, bgcolor: '#F5F6F3', borderRadius: '12px', p: 1.5 }}>
              <Box sx={{ width: 24, height: 24, bgcolor: '#0F231A', borderRadius: '50%', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 800, mb: 1, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                3
              </Box>
              <Typography sx={{ color: '#000', fontSize: '13px', fontWeight: 700, lineHeight: 1.2, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                Get paid on UPI
              </Typography>
            </Box>
          </Box>

          {/* Action Button */}
          <Button
            variant="contained"
            fullWidth
            onClick={() => navigate('/submit-task')}
            sx={{
              bgcolor: '#0F763F !important',
              color: '#fff',
              py: 2,
              borderRadius: '16px',
              fontSize: '18px',
              fontWeight: 800,
              textTransform: 'none',
              boxShadow: 'none',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              '&:hover': {
                bgcolor: '#0d6535 !important',
                boxShadow: 'none',
              }
            }}
          >
            Start task
          </Button>
        </Box>

        {/* App Demo Video */}
        <Box sx={{ width: '100%', mb: 4, display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ width: '100%', maxWidth: '400px' }}>
            <Box
              sx={{
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
              }}
              data-track="video_container"
              data-name="active_offer_app_demo_video"
            >
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  objectFit: 'cover',
                  transform: 'scale(1.03)',
                  borderRadius: '12px',
                  clipPath: 'inset(1px)'
                }}
              >
                <source src={appDemoVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </Box>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        {/* Footer info */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', color: '#0F763F', gap: 1, px: 1, pb: 4 }}>
          <VerifiedUserOutlinedIcon sx={{ fontSize: 18 }} />
          <Typography sx={{ color: '#666', fontSize: '13px', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
            Payouts go directly to your UPI ID
          </Typography>
        </Box>

      </Container>
    </Box>
  );
}
